module.exports = "https://store.zigzag.kr/resources/arm64/20260313-1604-1298abaedd_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";